<template>
  <div v-if="esVendedor" class="flex justify-center items-center p-2">
    <input type="text" class="form-control w-44" v-model="filtroClientes" @change="updateIdcli()" placeholder="Buscar cliente..">
  </div>
  <div v-if="esVendedor" class="flex justify-center items-center p-2">
    <p>Cliente: </p>
    <select placeholder="Seleccione un cliente" class="form-select w-72" v-model="idcli" @change="inicio()">
      <option value="" disabled selected hidden>Seleccione un cliente</option>
      <option v-for="(ex, key) in clientesFiltrados" :key="key" :value="ex.id">{{ ex.descripcion }}</option>
    </select>
  </div>
  <div class="flex justify-center min-h-[calc(100vh-200px)] font-primary mt-3">
    <div class="w-11/12">
      <div class="mb-2 flex gap-2 items-center" v-if="esVendedor && items.length != 0">
        <button class="btn bg-truered hover:bg-red-600 text-white mt-1" :disabled="cargando" @click="downloadExcel">Exportar Excel</button>
        <button class="btn bg-truered hover:bg-red-600 text-white mt-1" :disabled="cargando" @click="downloadPdf">Exportar PDF</button>
        <div class="flex gap-2">
          <label for="prc">Con precio</label>
          <input id="prc" type="checkbox" :disabled="cargando" v-model="conPrecio">
        </div>
      </div>
      <div v-if="cargando && !items.length" class="flex justify-center">
        <img  src="../assets/loading.gif" class="w-44"/>
      </div>
      <p class="text-center" v-if="cargando && !items.length">cargando...</p>
      <div v-for="(item, key) in items" :key="key" class="border-black-500 border">
        <div class="flex">
          <div class="row w-full">
              <div class="col-2 flex justify-center items-center">
                <img class="h-24 object-cover" :id="'imagen' + item.id" v-if="item.imagen1" :src='item.imagen1' alt="Imagen del articulo">
                <img class="h-24 object-cover" :id="'imagen' + item.id" v-else src='../assets/no-photo.jpg' alt="Imagen del articulo">
              </div>
              <div class="col-10">
                <div class="row w-full">
                  <div class="col-5">
                    <h5 class="modal-title text-left" id="exampleModalLabel">{{ item.DESCRIP_ART }}</h5>
                    <p class="modal-title text-[10px] text-left" id="exampleModalLabel">Código: {{ item.CODIGO_ART }}</p>
                  </div>
                  <div class="col-7 flex flex-wrap justify-around">
                    <div class="col-4">
                        <p class=" text-sm text-left">CANTIDAD:</p>
                        <input :title="(item.multiplo && item.multiplo != 1) ? ('Venta de ' + item.multiplo + ' unidades o multiplo') : ''" type="number" :disabled="cargando" class="form-control w-24" v-model="item.cantidadPedida" @change="updateItem(item)">
                    </div>

                    <div>
                      <p title="Precio Unitario" class="modal-title text-sm text-left py-2">Precio unitario: <br>${{ item.PRECIO_LPI }}</p>
                    </div>
                    
                    <div class="col-3">
                      <h5 v-if="item.PRECIO_LPI" class="modal-title text-left text-truered py-2">Subtotal: ${{ (item.PRECIO_LPI * item.cantidadPedida).toFixed(2) }}</h5>
                      <p v-if="item.obs" class="text-sm text-gray-400">Observacion: {{ item.obs }}</p>
                    </div>
                  
                  </div>
                </div>
              </div>
              <div>
            </div>
          </div>
          <button class="btn btn-outline" :disabled="cargando" @click="deleteItem(item)">Eliminar</button>
        </div>
      </div>

      <div>
        <RouterLink :to="'/catalogo' + (esVendedor ? ('?c='+this.idcli) : '')" class="btn btn-success btn-sm">+ Agregar articulos</RouterLink>
      </div>

      <h5 class="modal-title text-xl text-right p-2 border-2-black border-t border-b mt-2" id="exampleModalLabel">Total: ${{ totalPedido.toFixed(2) }}</h5>

      <div class="p-4" v-if="items.length == 0">
        <p>No hay items en tu carrito..</p>
      </div>
      <div v-else class="w-full m-2">
        <RouterLink :disabled="cargando" :to="'/confirmar-pedido' + ((esVendedor || idcli) ? '/' + idcli : '')" class="btn btn-danger bg-truered">Confirmar Pedido</RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
import pedidosService from '@/services/pedidos.service';
import configService from '@/services/config.service';
import usuarioService from '@/services/usuario.service';
import { defineComponent } from 'vue';

export default defineComponent({
    mounted() {
      configService.checkHabilitado("CARRITO")
      .then((res) => {
        if (res.data == 1) {
          this.inicio()
          if (!this.esSupervisor && this.esVendedor) {
            this.cargarClientes()
          }
          if (this.esSupervisor) {
            this.cargarTodosLosClientes()
          }
        } else {
          this.$router.push("/mantenimiento")
        }
      })
      .catch(err => {
        console.log(err)
        this.$router.push("/mantenimiento")
      })
    },
    data() {
        return {
          items: [],
          userId: '',
          idcli: '',
          clientes: [],
          filtroClientes: '',
          cargando: false,
          conPrecio: true,
        }
    },
    computed: {
      clientesFiltrados() {
        if (!this.filtroClientes) {
          return this.clientes
        } else {
          return this.clientes.filter(x => x.descripcion.toLowerCase().includes(this.filtroClientes))
        }
      },
      totalPedido() {
        var total = 0
        if (this.items.length > 0) {
          this.items.forEach(x => {
            total += (x.PRECIO_LPI * x.cantidadPedida)
          })
        }
        return total
      },
      esVendedor() {
        return this.$root.user.tipo != "cliente";
      },
      esSupervisor() {
        return this.esVendedor && ['admin', 'supervisor'].includes(this.$root.user.tipo)
      }
    },
    methods: {
      async downloadPdf() {
        try {
            this.cargando = true
            var user = JSON.parse(localStorage.getItem('user'))
            this.userId = user.id
            pedidosService.generarCatalogoCustom(user.id, this.idcli, this.conPrecio ? 1 : 0)
          .then(res => {
            const blob = new Blob([res.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            const today = new Date();
            const day = String(today.getDate()).padStart(2, '0');
            const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
            const year = today.getFullYear();
            link.setAttribute('download', 'catalogo-'+`${day}-${month}-${year}`+'.pdf'); // Set the filename for the downloaded file
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch((er) => {
            console.log(er)
          })
          .finally(() => {
            this.cargando = false
          })
        } catch (error) {
            console.error('Error downloading Pdf:', error);
            this.cargando = false
        }
      },
      async downloadExcel() {
        try {
            this.cargando = true
            const response = await pedidosService.getExcelCarrito(this.userId, this.idcli)

            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'cotizacion.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.cargando = false
        } catch (error) {
            console.error('Error downloading Excel:', error);
            this.cargando = false
        }
      },

      updateIdcli() {
        this.idcli = this.clientesFiltrados[0].id
        this.inicio()
      },
      // cargarTodosLosClientes() {
      //   usuarioService.getAllClientesCarritos()
      //   .then((res) => {
      //     this.clientes = res.data.map(c => ({
      //       id: c.ID_CLI,
      //       descripcion: c.RAZONSOCIAL_CLI
      //     }))
      //     this.idcli = this.clientes[0].id
      //     this.inicio()
      //   })
      //   .then(() => {
      //     this.itemsCarrito()
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })
      // },
      cargarTodosLosClientes() {
        this.cargarClientes()
      },
      cargarClientes() {
        usuarioService.getClientesCarritos(this.$root.user.id)
          .then((res) => {
            this.clientes = res.data.map(c => ({
              id: c.ID_CLI,
              descripcion: c.RAZONSOCIAL_CLI
            }))
            this.idcli = this.$route.query.id || this.clientes[0].id
            this.inicio()
          })
          .catch(err => {
            console.log(err)
          })
      },
      inicio() {
        var user = JSON.parse(localStorage.getItem('user'))
        this.userId = user.id
        if (!this.esVendedor || this.idcli) {
          this.cargando = true
          pedidosService.getItemsCarritoCliente(user.id, this.idcli)
            .then(res => {
              if (res.data) {
                this.items = res.data.sort((a, b) => a.id - b.id )
                this.items.forEach((x, i) => this.buscarFotos(i))
              }
            })
            .catch(err => {
              console.log(err)
            })
            .finally(() => {
              this.cargando = false
            })
          this.updateCounter(user.id)
        }
      },
      updateCounter(id) {
        pedidosService.getCountItemsCarritoCliente(id, this.idcli)
          .then((res) => {
            this.$root.itemsCarrito = res.data
          })
          .catch(err => {
            console.log(err)
          })
      },
      buscarFotos(index) {
        pedidosService.getImagenProducto(this.items[index].IDART_IO, 1)
          .then(res => {
            if (res.data.byteLength === 0) {
              if (this.items[index]) {
                this.items[index].imagen1 = ''
              }
              return  
            }
            const imageBlob = new Blob([res.data], { type: 'image/*' })
            if (this.items[index]) {
              this.items[index].imagen1 = URL.createObjectURL(imageBlob)
            }
          })
          .catch((err) => {
            console.log(err)
            if (this.items[index]) {
              this.items[index].imagen1 = ''
            }
          })
      },
      updateItem(item) {
        if (!item.multiplo) {
          item.multiplo = 1
        }
        if (item.IDART_IO && item.cantidadPedida && item.cantidadPedida > 0) {
          if (item.cantidadPedida % item.multiplo != 0) {
            item.cantidadPedida = Math.round(item.cantidadPedida / item.multiplo) * item.multiplo
            console.log(item.cantidadPedida)
          }
          var itm = {
            id: item.id,
            idart: item.IDART_IO,
            cantidad: item.cantidadPedida,
            obs: item.obs ? item.obs : null,
            idcli: this.esVendedor ? this.idcli : null
          }
          this.cargando = true
          pedidosService.postItemsCarrito(itm)
            .then(() => {
              this.cargando = false
              this.$root.alertSuccess = true
              this.$root.isAlertVisible = true
              // cartel de exito y borrar datos de "item"
            })
            .catch((err) => {
              this.cargando = false
              this.$root.alertSuccess = false
              this.$root.isAlertVisible = true
              console.log(err)
            })
        } else if (item.id) {
          this.deleteItem(item)
        } else {
          this.errorItem = 'Debe ingresar una cantidad validad'
        }
      },
      deleteItem(item) {
        this.items.splice(this.items.indexOf(item), 1)
        this.cargando = true
        pedidosService.deleteItemCarrito(item.id)
          .then(() => {
            this.$root.alertSuccess = true
            this.$root.isAlertVisible = true
            this.updateCounter(this.userId)
          })
          .catch(err => {
            this.$root.alertSuccess = true
            this.$root.isAlertVisible = true
            console.log(err)
          })
          .finally(() => {
            this.cargando = false
          })
      }
    }
})
</script>